import { render, staticRenderFns } from "./InventoryRouter.vue?vue&type=template&id=17c39538&"
import script from "./InventoryRouter.vue?vue&type=script&lang=js&"
export * from "./InventoryRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports